import { render } from "./AttendanceHistory.vue?vue&type=template&id=4005dae2"
import script from "./AttendanceHistory.vue?vue&type=script&lang=js"
export * from "./AttendanceHistory.vue?vue&type=script&lang=js"

import "./AttendanceHistory.vue?vue&type=style&index=0&id=4005dae2&lang=css"

import exportComponent from "D:\\CAS Project\\ESM Web App\\master ESM-WEB\\esm-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__